import React from 'react';

import { Layout, Text } from 'ds';

interface QuantityPillButtonProps {
  quantity: number;
}

const QuantityPillButton: React.FC<QuantityPillButtonProps> = ({ quantity }) => {
  return (
    <Layout
      width={40}
      height={40}
      borderRadius="circular"
      align="center"
      paddingX={8}
      boxShadow="2.5px 0px 27.5px 0px rgba(87, 73, 109, 0.12)"
      justify="center"
      color="white"
      borderColor="gray-50"
      borderWidth={1}
    >
      <Text size="body-md" bold>
        {quantity}
      </Text>
    </Layout>
  );
};

export default QuantityPillButton;
